export const allTypeListCategory = {
    id: 999,
    name: 'Ver tudo',
    description: '',
    availabilityControl: false,
    active: true,
    category: {
        active: true,
        enumKey: 7,
        name: 'Ondas',
        id: 99,
    },
    icon: '',
    orderBy: 99,
};

export const parkTicketEnumKey = 2;
export const surfTicketEnumKey = 1;
